import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2, AlertCircle } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Google redirects the browser here with `?code=...`. We POST the code to the
// backend along with the EXACT same redirect_uri we used to start the flow
// (window.location.origin + "/auth/google/callback"), so Google's token
// exchange accepts it.
export default function GoogleCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [err, setErr] = useState(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const code = params.get("code");
    const errParam = params.get("error");
    if (errParam) {
      setErr(`Google sign-in cancelled: ${errParam}`);
      return;
    }
    if (!code) {
      setErr("Missing authorization code from Google.");
      return;
    }
    const redirect_uri = `${window.location.origin}/auth/google/callback`;
    (async () => {
      try {
        const { data } = await api.post("/auth/google/exchange", { code, redirect_uri });
        setUser(data);
        nav(data.onboarded ? "/dashboard" : "/onboarding", { replace: true });
      } catch (e) {
        const detail = e?.response?.data?.detail || e.message || "Sign-in failed";
        setErr(typeof detail === "string" ? detail : JSON.stringify(detail));
      }
    })();
  }, [params, nav, setUser]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-zinc-100 flex items-center justify-center p-6">
      <div className="max-w-sm w-full text-center space-y-4" data-testid="google-callback">
        {err ? (
          <>
            <AlertCircle className="mx-auto text-[#EF4444]" size={28} />
            <div className="text-sm font-mono text-[#EF4444]" data-testid="google-callback-error">
              {err}
            </div>
            <button
              type="button"
              onClick={() => nav("/login", { replace: true })}
              className="text-[#00E5FF] text-sm font-mono hover:underline"
            >
              back to login
            </button>
          </>
        ) : (
          <>
            <Loader2 className="mx-auto animate-spin text-[#00E5FF]" size={28} />
            <div className="text-sm font-mono text-zinc-400">
              completing google sign-in…
            </div>
          </>
        )}
      </div>
    </div>
  );
}
